import React from 'react';
import PropTypes from 'prop-types';

import './SubTitleHeader.css';

const SubTitleHeader = ({ name }) => (
  <div className="subtitle-header">
    <span className="-eva-3-tc-gray-0">{name}</span>
  </div>
);

SubTitleHeader.propTypes = {
  name: PropTypes.string.isRequired
};

export default SubTitleHeader;
